import React from 'react';
import { motion } from 'framer-motion';
import { toolCategories } from '../../data/toolCategories';
import {
  IntroText,
  CategoryContainer,
  CategoryHeader,
  ToolsGrid,
  ToolCard,
  ToolName,
  ToolDescription,
  ToolLink,
  itemVariants,
  categoryVariants,
  toolVariants
} from './styles/ToolsTabStyles';
import { TabContainer, Section } from '../shared/TabStyles';

const ToolsTab = () => {
  return (
    <TabContainer>
      <Section>
        <motion.div variants={itemVariants}>
          
          {toolCategories.map((category, categoryIndex) => (
            <CategoryContainer key={category.title}>
              <motion.div 
                variants={categoryVariants} 
                initial="hidden" 
                animate="visible"
                transition={category.transitionDelay ? { delay: category.transitionDelay } : undefined}
              >
                <CategoryHeader>
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                </CategoryHeader>
                
                <ToolsGrid>
                  {category.tools.map((tool, toolIndex) => (
                    <motion.div key={tool.name} variants={toolVariants} whileHover="hover">
                      <ToolCard highlight={tool.highlight}>
                        <ToolName>{tool.name}</ToolName>
                        <ToolDescription>
                          {tool.description}
                          {tool.referralLink && (
                            <>
                              <br />
                              <ToolLink href={tool.referralLink} target="_blank" rel="noopener noreferrer">
                                {tool.referralText || "Referral link →"}
                              </ToolLink>
                            </>
                          )}
                        </ToolDescription>
                      </ToolCard>
                    </motion.div>
                  ))}
                </ToolsGrid>
              </motion.div>
            </CategoryContainer>
          ))}
        
        </motion.div>
      </Section>
    </TabContainer>
  );
};

export default ToolsTab; 